// Enhanced functionality for no-shims product template
document.addEventListener('DOMContentLoaded', function() {

  const settings = window.coopersridgeSettings || {
    enableEnhancedFeatures: true,
    defaultFontSize: 'normal',
    defaultTextAlignment: 'left',
    enableEnhancedModal: true,
    showStickyCart: true,
    showProductSpecs: true,
    showTrustBadges: true,
    modalInstructionsText: 'Click and drag to pan • Scroll to zoom • ESC to close',
    stickyCartButtonText: 'Add to Cart',
    stickyCartBgColor: '#ffffff',
    stickyCartBorderColor: '#E31E24',
    stickyCartTitleColor: '#E31E24',
    stickyCartPriceColor: '#E31E24',
    stickyCartButtonBg: '#E31E24',
    stickyCartButtonTextColor: '#ffffff',
    stickyCartShadowOpacity: 15
  };
  
  // Apply theme editor settings for font size and alignment
  function applyThemeSettings() {
    if (!settings.enableEnhancedFeatures) return;

    setTimeout(() => {
      setFontSize(settings.defaultFontSize);
      setTextAlignment(settings.defaultTextAlignment);
    }, 100);
  }
  
  function setFontSize(size) {
    const target = document.querySelector('.template-product') || document.body;
    target.classList.remove('font-size-small', 'font-size-large', 'font-size-extra-large');
    if (size !== 'normal') {
      target.classList.add(`font-size-${size}`);
    }
  }

  function setTextAlignment(align) {
    const target = document.body;
    target.classList.remove('text-align-left', 'text-align-center', 'text-align-right');
    target.classList.add(`text-align-${align}`);
  }
  
  // Sticky add to cart
  function initStickyCart() {
    if (!settings.enableEnhancedFeatures || !settings.showStickyCart) return;
    
    const productForm = document.querySelector('.product-form');
    const buyButtons = document.querySelector('.product-form__buttons');
    
    if (!productForm || !buyButtons) return;
    
    // Create sticky cart
    const stickyCart = document.createElement('div');
    stickyCart.className = 'sticky-cart';
    
    // Get clean product title (remove duplicates)
    const rawTitle = document.querySelector('.product__title')?.textContent?.trim() || 'Product';
    
    // Check if title is duplicated by splitting and comparing halves
    const words = rawTitle.split(/\s+/);
    let productTitle = rawTitle;
    
    // Try to detect if the title is repeated
    if (words.length >= 2 && words.length % 2 === 0) {
      const halfLength = words.length / 2;
      const firstHalf = words.slice(0, halfLength).join(' ');
      const secondHalf = words.slice(halfLength).join(' ');
      
      if (firstHalf === secondHalf) {
        productTitle = firstHalf;
      }
    }
    
    // Also check if the title contains itself as a substring
    const titleWords = productTitle.split(/\s+/);
    if (titleWords.length >= 2) {
      const possibleTitle = titleWords.slice(0, Math.ceil(titleWords.length / 2)).join(' ');
      if (productTitle.includes(possibleTitle + ' ' + possibleTitle)) {
        productTitle = possibleTitle;
      }
    }
    
    // Get selected variant name (clean it up)
    const selectedVariant = document.querySelector('.product-form__input input[type="radio"]:checked + label') ||
                           document.querySelector('.product-form__input .swatch input:checked + label') ||
                           document.querySelector('variant-selects select option:checked') ||
                           document.querySelector('variant-radios input:checked + label');
    let variantName = selectedVariant?.textContent?.trim() || '';
    
    // Clean up variant name - remove "Variant sold out or unavailable" and just get the color
    variantName = variantName.replace(/\s*Variant sold out or unavailable\s*/gi, '').trim();
    
    // Create display title with variant
    const displayTitle = variantName ? `${productTitle} - ${variantName}` : productTitle;
    
    // Get only the visible price amount
    const priceElement = document.querySelector('.price__container .price__regular .price-item--regular') || 
                        document.querySelector('.price__container .price__sale .price-item--sale') ||
                        document.querySelector('.price');
    const productPrice = priceElement?.textContent?.trim() || '';
    // Get the first product image, preferably the featured one
    const productImage = document.querySelector('.product__media-item--variant:first-child img')?.src || 
                        document.querySelector('.product__media-item img')?.src || 
                        document.querySelector('.product__media img')?.src || '';
    
    // Inject custom styles from theme settings
    // Remove existing custom styles if any
    const existingStyles = document.getElementById('sticky-cart-custom-styles');
    if (existingStyles) existingStyles.remove();
    
    const customStyles = document.createElement('style');
    customStyles.id = 'sticky-cart-custom-styles';
    customStyles.textContent = `
      .sticky-cart {
        background: ${settings.stickyCartBgColor} !important;
        border-top: 4px solid ${settings.stickyCartBorderColor} !important;
        box-shadow: 0 -4px 20px rgba(0, 0, 0, ${settings.stickyCartShadowOpacity / 100}) !important;
      }
      .sticky-cart-details h4 {
        color: ${settings.stickyCartTitleColor} !important;
      }
      .sticky-cart-price {
        color: ${settings.stickyCartPriceColor} !important;
      }
      .sticky-cart-buttons .product-form__submit {
        background: ${settings.stickyCartButtonBg} !important;
        color: ${settings.stickyCartButtonTextColor} !important;
        border: none !important;
      }
      .sticky-cart-buttons .product-form__submit:hover {
        background: ${settings.stickyCartButtonBg} !important;
        opacity: 0.9 !important;
      }
    `;
    document.head.appendChild(customStyles);
    
    // Clone only the add to cart button
    const originalButton = buyButtons.querySelector('.product-form__submit');
    const buttonClone = originalButton ? originalButton.cloneNode(true) : null;
    
    stickyCart.innerHTML = `
      <div class="sticky-cart-content">
        <div class="sticky-cart-info">
          <div class="sticky-cart-image">
            ${productImage ? `<img src="${productImage}" alt="${productTitle}" />` : ''}
          </div>
          <div class="sticky-cart-details">
            <h4>${displayTitle}</h4>
            <div class="sticky-cart-price">${productPrice}</div>
          </div>
        </div>
        <div class="sticky-cart-buttons"></div>
      </div>
    `;
    
    // Add the cloned button
    const buttonsContainer = stickyCart.querySelector('.sticky-cart-buttons');
    if (buttonClone) {
      buttonsContainer.appendChild(buttonClone);

      // Update button text if specified
      const stickyButton = buttonClone.querySelector('span');
      if (stickyButton && settings.stickyCartButtonText) {
        stickyButton.textContent = settings.stickyCartButtonText;
      }

      // Make sure the button works - only if original is enabled
      buttonClone.addEventListener('click', function(e) {
        e.preventDefault();
        if (!originalButton.disabled && originalButton.getAttribute('aria-disabled') !== 'true') {
          originalButton.click();
        }
      });

      // Sync sticky button state with original button
      function syncButtonState() {
        const isDisabled = originalButton.disabled || originalButton.getAttribute('aria-disabled') === 'true';
        buttonClone.disabled = isDisabled;
        if (isDisabled) {
          buttonClone.setAttribute('aria-disabled', 'true');
        } else {
          buttonClone.removeAttribute('aria-disabled');
        }
        // Update button text to match original
        const originalText = originalButton.querySelector('span')?.textContent;
        const cloneText = buttonClone.querySelector('span');
        if (originalText && cloneText && originalText !== settings.stickyCartButtonText) {
          cloneText.textContent = originalText;
        } else if (cloneText && !isDisabled) {
          cloneText.textContent = settings.stickyCartButtonText;
        }
      }

      // Watch for changes to the original button
      const buttonObserver = new MutationObserver(syncButtonState);
      buttonObserver.observe(originalButton, {
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled']
      });
    }
    
    document.body.appendChild(stickyCart);
    
    // Show/hide based on scroll position
    let isVisible = false;
    
    function toggleStickyCart() {
      const buyButtonsRect = buyButtons.getBoundingClientRect();
      const shouldShow = buyButtonsRect.bottom < 0;
      
      if (shouldShow && !isVisible) {
        stickyCart.classList.add('visible');
        isVisible = true;
      } else if (!shouldShow && isVisible) {
        stickyCart.classList.remove('visible');
        isVisible = false;
      }
    }
    
    window.addEventListener('scroll', toggleStickyCart);
    window.addEventListener('resize', toggleStickyCart);
    
    // Function to update sticky cart content
    function updateStickyCart() {
      // Re-get the selected variant and update the title
      const newSelectedVariant = document.querySelector('.product-form__input input[type="radio"]:checked + label') ||
                                document.querySelector('.product-form__input .swatch input:checked + label') ||
                                document.querySelector('variant-selects select option:checked') ||
                                document.querySelector('variant-radios input:checked + label');
      let newVariantName = newSelectedVariant?.textContent?.trim() || '';
      
      // Clean up variant name
      newVariantName = newVariantName.replace(/\s*Variant sold out or unavailable\s*/gi, '').trim();
      
      const newDisplayTitle = newVariantName ? `${productTitle} - ${newVariantName}` : productTitle;
      
      // Update the sticky cart title
      const stickyTitle = stickyCart.querySelector('.sticky-cart-details h4');
      if (stickyTitle) {
        stickyTitle.textContent = newDisplayTitle;
      }
      
      // Update price if it changed
      const newPriceElement = document.querySelector('.price__container .price__regular .price-item--regular') || 
                             document.querySelector('.price__container .price__sale .price-item--sale') ||
                             document.querySelector('.price');
      const newPrice = newPriceElement?.textContent?.trim() || '';
      const stickyPrice = stickyCart.querySelector('.sticky-cart-price');
      if (stickyPrice) {
        stickyPrice.textContent = newPrice;
      }
      
      // Update image if variant has specific image
      // Try multiple selectors for the current variant image
      const variantImage = document.querySelector('.product__media-item.is-active img')?.src ||
                          document.querySelector('.product__media-item--variant.is-active img')?.src ||
                          document.querySelector('.product__modal-opener--image.is-active img')?.src ||
                          document.querySelector('.product__media img[data-media-id]:not([hidden])')?.src ||
                          document.querySelector('.product__media-list .is-active img')?.src ||
                          document.querySelector('li[data-media-id].is-active img')?.src;
      
      if (variantImage) {
        const stickyImage = stickyCart.querySelector('.sticky-cart-image img');
        if (stickyImage) {
          stickyImage.src = variantImage;

        }
      }
    }
    
    // Listen for various variant change events
    document.addEventListener('variant:change', updateStickyCart);
    document.addEventListener('variant:switch', updateStickyCart);
    
    // Also listen for change events on variant inputs
    const variantInputs = document.querySelectorAll('.product-form__input input[type="radio"], variant-selects select, variant-radios input');
    variantInputs.forEach(input => {
      input.addEventListener('change', function() {
        setTimeout(updateStickyCart, 100); // Small delay to ensure DOM updates
      });
    });
    
    // Monitor for price changes using MutationObserver
    const priceContainer = document.querySelector('.price__container');
    if (priceContainer) {
      const observer = new MutationObserver(function(mutations) {
        updateStickyCart();
      });
      
      observer.observe(priceContainer, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
    
    // Also monitor media gallery for image changes
    const mediaGallery = document.querySelector('.product__media-list') || 
                        document.querySelector('.product__media-wrapper') ||
                        document.querySelector('[id^="GalleryViewer"]');
    if (mediaGallery) {
      const mediaObserver = new MutationObserver(function(mutations) {
        // Delay to ensure class changes have been applied
        setTimeout(function() {
          // Find the currently visible/active image
          const currentImage = document.querySelector('.product__media-item:not(.is-hidden) img') ||
                              document.querySelector('.product__media-item.is-active img') ||
                              document.querySelector('.product__modal-opener--image:not([hidden]) img') ||
                              document.querySelector('[data-media-id]:not([hidden]) img') ||
                              document.querySelector('.product__media:first-child img');
          
          if (currentImage && currentImage.src) {
            const stickyImage = stickyCart.querySelector('.sticky-cart-image img');
            if (stickyImage && stickyImage.src !== currentImage.src) {
              stickyImage.src = currentImage.src;

            }
          }
        }, 150);
      });
      
      mediaObserver.observe(mediaGallery, {
        attributes: true,
        attributeFilter: ['class', 'hidden', 'style'],
        childList: true,
        subtree: true
      });
    }
  }
  
  // Enhanced product specifications
  function addProductSpecs() {
    if (!settings.enableEnhancedFeatures || !settings.showProductSpecs) return;
    
    const description = document.querySelector('.product__description');
    if (!description) return;
    
    // Add specs section after description
    const specsSection = document.createElement('div');
    specsSection.className = 'product-specs';
    specsSection.innerHTML = `
      <h3>Product Specifications</h3>
      <div class="specs-grid">
        <div class="spec-item">
          <span class="spec-label">Material</span>
          <span class="spec-value">85% Cotton, Poly Fill</span>
        </div>
        <div class="spec-item">
          <span class="spec-label">Construction</span>
          <span class="spec-value">Quilted with Micro-Suede Top</span>
        </div>
        <div class="spec-item">
          <span class="spec-label">Origin</span>
          <span class="spec-value">Made in Canada 🇨🇦</span>
        </div>
        <div class="spec-item">
          <span class="spec-label">Warranty</span>
          <span class="spec-value">2 Years Manufacturing</span>
        </div>
        <div class="spec-item">
          <span class="spec-label">Care</span>
          <span class="spec-value">Hand Wash, Air Dry</span>
        </div>
        <div class="spec-item">
          <span class="spec-label">Girth Straps</span>
          <span class="spec-value">Dual Options Available</span>
        </div>
      </div>
    `;
    
    description.parentNode.insertBefore(specsSection, description.nextSibling);
  }
  
  // Enhanced image modal
  function initImageModal() {
    if (!settings.enableEnhancedFeatures || !settings.enableEnhancedModal) return;

    // Don't add custom modal if Dawn's lightbox is already handling image zoom
    const productInfo = document.querySelector('product-info');
    if (productInfo && productInfo.dataset.zoomOnHover !== undefined) return;
    const dawnLightbox = document.querySelector('.product__modal-opener');
    if (dawnLightbox) return;

    const productImages = document.querySelectorAll('.product__media img');

    productImages.forEach(img => {
      img.style.cursor = 'zoom-in';

      img.addEventListener('click', function() {
        createImageModal(this);
      });
    });
  }
  
  function createImageModal(img) {
    // Create modal structure
    const modal = document.createElement('div');
    modal.className = 'image-modal';
    modal.innerHTML = `
      <div class="image-modal__backdrop"></div>
      <div class="image-modal__content">
        <button class="image-modal__close" aria-label="Close modal">&times;</button>
        <div class="image-modal__image-container">
          <img src="${img.src}" alt="${img.alt}" class="image-modal__image" />
        </div>
        <div class="image-modal__info">
          <h3>${document.querySelector('.product__title')?.textContent || 'Product Image'}</h3>
          <p>${settings.modalInstructionsText}</p>
        </div>
      </div>
    `;
    
    document.body.appendChild(modal);
    document.body.style.overflow = 'hidden';
    
    // Add modal styles
    const modalStyles = document.createElement('style');
    modalStyles.textContent = `
      .image-modal {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 10000;
        display: flex;
        align-items: center;
        justify-content: center;
        animation: modalFadeIn 0.3s ease;
      }
      
      .image-modal__backdrop {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.95);
        backdrop-filter: blur(10px);
      }
      
      .image-modal__content {
        position: relative;
        max-width: 95%;
        max-height: 95%;
        background: white;
        border-radius: 16px;
        overflow: hidden;
        box-shadow: 0 25px 80px rgba(0, 0, 0, 0.5);
        display: flex;
        flex-direction: column;
      }
      
      .image-modal__close {
        position: absolute;
        top: 1rem;
        right: 1rem;
        width: 40px;
        height: 40px;
        border: none;
        background: rgba(0, 0, 0, 0.7);
        color: white;
        border-radius: 50%;
        font-size: 24px;
        cursor: pointer;
        z-index: 10001;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.3s ease;
      }
      
      .image-modal__close:hover {
        background: var(--color-coopersridge-red);
        transform: scale(1.1);
      }
      
      .image-modal__image-container {
        position: relative;
        flex: 1;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 400px;
        background: #f8f9fa;
      }
      
      .image-modal__image {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
        transition: transform 0.3s ease;
        cursor: grab;
      }
      
      .image-modal__image:active {
        cursor: grabbing;
      }
      
      .image-modal__info {
        padding: 1.5rem;
        background: white;
        border-top: 1px solid #e9ecef;
      }
      
      .image-modal__info h3 {
        margin: 0 0 0.5rem 0;
        color: var(--color-coopersridge-red);
        font-size: 1.25rem;
        font-weight: 600;
      }
      
      .image-modal__info p {
        margin: 0;
        color: #6c757d;
        font-size: 0.875rem;
      }
      
      @keyframes modalFadeIn {
        from { opacity: 0; transform: scale(0.9); }
        to { opacity: 1; transform: scale(1); }
      }
      
      @media (max-width: 768px) {
        .image-modal__content {
          max-width: 98%;
          max-height: 98%;
        }
        
        .image-modal__info {
          padding: 1rem;
        }
        
        .image-modal__close {
          top: 0.5rem;
          right: 0.5rem;
          width: 35px;
          height: 35px;
          font-size: 20px;
        }
      }
    `;
    
    document.head.appendChild(modalStyles);
    
    // Add pan and zoom functionality
    const modalImage = modal.querySelector('.image-modal__image');
    let scale = 1;
    let isDragging = false;
    let startX, startY, translateX = 0, translateY = 0;
    
    // Zoom with mouse wheel
    modal.addEventListener('wheel', function(e) {
      e.preventDefault();
      const delta = e.deltaY > 0 ? 0.9 : 1.1;
      scale *= delta;
      scale = Math.max(0.5, Math.min(scale, 3));
      updateImageTransform();
    });
    
    // Pan functionality
    modalImage.addEventListener('mousedown', startDrag);
    modalImage.addEventListener('touchstart', startDrag);
    
    function startDrag(e) {
      isDragging = true;
      const clientX = e.clientX || e.touches[0].clientX;
      const clientY = e.clientY || e.touches[0].clientY;
      startX = clientX - translateX;
      startY = clientY - translateY;
      modalImage.style.cursor = 'grabbing';
    }
    
    document.addEventListener('mousemove', drag);
    document.addEventListener('touchmove', drag);
    
    function drag(e) {
      if (!isDragging) return;
      e.preventDefault();
      const clientX = e.clientX || e.touches[0].clientX;
      const clientY = e.clientY || e.touches[0].clientY;
      translateX = clientX - startX;
      translateY = clientY - startY;
      updateImageTransform();
    }
    
    document.addEventListener('mouseup', stopDrag);
    document.addEventListener('touchend', stopDrag);
    
    function stopDrag() {
      isDragging = false;
      modalImage.style.cursor = 'grab';
    }
    
    function updateImageTransform() {
      modalImage.style.transform = `translate(${translateX}px, ${translateY}px) scale(${scale})`;
    }
    
    // Close modal functionality
    function closeModal() {
      document.body.removeChild(modal);
      document.head.removeChild(modalStyles);
      document.body.style.overflow = '';
      document.removeEventListener('mousemove', drag);
      document.removeEventListener('touchmove', drag);
      document.removeEventListener('mouseup', stopDrag);
      document.removeEventListener('touchend', stopDrag);
    }
    
    // Close on backdrop click
    modal.querySelector('.image-modal__backdrop').addEventListener('click', closeModal);
    
    // Close on close button click
    modal.querySelector('.image-modal__close').addEventListener('click', closeModal);
    
    // Close on escape key
    const closeOnEscape = function(e) {
      if (e.key === 'Escape') {
        closeModal();
        document.removeEventListener('keydown', closeOnEscape);
      }
    };
    document.addEventListener('keydown', closeOnEscape);
  }
  
  // Smooth scroll to sections
  function initSmoothScroll() {
    const accordionTitles = document.querySelectorAll('.accordion summary');
    
    accordionTitles.forEach(title => {
      title.addEventListener('click', function(e) {
        setTimeout(() => {
          this.scrollIntoView({ 
            behavior: 'smooth', 
            block: 'center' 
          });
        }, 100);
      });
    });
  }
  
  // Loading animation
  function initLoadingAnimation() {
    const productInfo = document.querySelector('.product__info-wrapper');
    if (!productInfo) return;
    
    // Add loading class initially
    productInfo.classList.add('loading');
    
    // Remove loading class after a short delay
    setTimeout(() => {
      productInfo.classList.remove('loading');
    }, 500);
  }
  
  // Initialize all features
  // Check multiple ways to detect product page
  const isProductPage = document.body.classList.contains('template-product') || 
                       document.querySelector('.product') || 
                       document.querySelector('[data-section-type="product"]') ||
                       document.querySelector('.product__info') ||
                       window.location.pathname.includes('/products/');
  
  if (isProductPage) {
    applyThemeSettings();
    initStickyCart();
    initImageModal();
    initSmoothScroll();
    initLoadingAnimation();
  }
});